"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtomicSearchBoxInstantResults = exports.AtomicFoldedResultList = exports.AtomicResultList = exports.AtomicSearchInterface = void 0;
__exportStar(require("./stencil-generated/index"), exports);
__exportStar(require("@coveo/headless"), exports);
// Important: Re-exporting under the same name (eg: "AtomicSearchInterface") shadows the original component
// and should wrap it nicely for users of the library
var SearchInterfaceWrapper_1 = require("./SearchInterfaceWrapper");
Object.defineProperty(exports, "AtomicSearchInterface", { enumerable: true, get: function () { return SearchInterfaceWrapper_1.SearchInterfaceWrapper; } });
var ResultListWrapper_1 = require("./ResultListWrapper");
Object.defineProperty(exports, "AtomicResultList", { enumerable: true, get: function () { return ResultListWrapper_1.ResultListWrapper; } });
var FoldedResultListWrapper_1 = require("./FoldedResultListWrapper");
Object.defineProperty(exports, "AtomicFoldedResultList", { enumerable: true, get: function () { return FoldedResultListWrapper_1.FoldedResultListWrapper; } });
var SearchBoxInstantResultsWrapper_1 = require("./SearchBoxInstantResultsWrapper");
Object.defineProperty(exports, "AtomicSearchBoxInstantResults", { enumerable: true, get: function () { return SearchBoxInstantResultsWrapper_1.SearchBoxInstantResultsWrapper; } });
//# sourceMappingURL=index.js.map